import { render } from "./SelecionarCstIcms.vue?vue&type=template&id=71ba770e&ts=true"
import script from "./SelecionarCstIcms.vue?vue&type=script&lang=ts"
export * from "./SelecionarCstIcms.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__